import { useState, useEffect, use, useRef } from "react";
import GoMap from "../GoMap";
import { Link, useParams } from "react-router";
import ObserverAltura from "../ObserverAltura";
import WS from "./webservice";
import DestinoOrganizado from "./destino_organizado";
import DestinosOrganizado from "../destinos_organizado";
import DadosMotorista from "./dados_motorista";
import StatusCorrida from "./status_corrida";
import DadosCorrida from "./dados_corrida";
import { SpinnerCircular } from "spinners-react";
import StarAvaliacao from "./star_avaliacao";
import Loader from "../loading";
import OtpPrompt from "../otp_promtp.js";
import { Navigation, Car, ArrowLeft, User } from "lucide-react";

import { WhatsappShareButton, WhatsappIcon } from "react-share";
import * as S from "../styles";

function Main() {
  const [alturaFilho, setAlturaFilho] = useState(0);
  const [trajeto, setTrajeto] = useState({});
  const [timerOtp, setTimerOtp] = useState(0);
  const incrementer = useRef(null);
  const [showOtp, setShowOtp] = useState(false);

  const [msgErro, setMsgErro] = useState("");
  const [showMap, setShowMap] = useState(true);
  const [alturaFilhoTopo, setAlturaFilhoTopo] = useState(0);
  const [corrida, setCorrida] = useState({});
  const [statusCorrida, setStatusCorrida] = useState("");
  const [marcadores, setMarcadores] = useState([]);
  const [motorista, setMotorista] = useState({});
  const [motorista_dados, setMotoristaDados] = useState([]);
  const [motorista_marker, setMotoristaMarker] = useState([]);
  const [pontos, setPontos] = useState([]);
  const [pontos2, setPontos2] = useState([]);
  const [origem, setOrigem] = useState({});
  const [destinos, setDestinos] = useState([]);
  const [questoes, setQuestoes] = useState([]);
  const { xd } = useParams();
  const [showLoader, setShowLoader] = useState(true);

  const avaliarCorrida = async (resposta, star) => {
    setShowLoader(true);
    WS.saveAvaliacao(xd, resposta, star).then((result) => {
      loadCorrida();
    });
  };
  const loadCorrida = () => {
    if (xd && xd.length > 0) {
      WS.getCorrida(xd).then((result) => {
        if (!!result.dados) {
          setCorrida(result.dados);
        }
        if (!!result.questoes) {
          setQuestoes(result.questoes);
        }
        if (!!result.status) {
          setStatusCorrida(result.status);
        }
        if (!!result.dados && !!result.dados.motorista) {
          setMotorista(result.dados.motorista);
          setMotoristaDados(result.dados.motorista_dados);
        }
        let m = [];

        if (!!result.dados && !!result.dados.dados_rota) {
          setPontos(result.dados.dados_rota.pontos);
        }
        if (!!result.dados && !!result.dados.enderecoscomponentes && !!result.dados.enderecoscomponentes.origem) {
          m.push({
            latitude: result.dados.enderecoscomponentes.origem.latitude,
            longitude: result.dados.enderecoscomponentes.origem.longitude,
            title: "Origem",
          });
          setOrigem(result.dados.enderecoscomponentes.origem);
        }
        let mot = [];
        if (!!result.dados && !!result.motorista) {
          mot.push({
            latitude: result.dados.motorista.latitude,
            longitude: result.dados.motorista.longitude,
            title: "Motorista",
          });
        }
        setMotoristaMarker(mot);

        if (!!result.trajeto) {
          setTrajeto(result.trajeto);
          setPontos2(result.trajeto.shape);
        } else if (!!result.rotapoints) {
          setPontos2(result.rotapoints);
        }
        if (!!result.dados && !!result.dados.enderecoscomponentes && !!result.dados.enderecoscomponentes.destino) {
          m.push({
            latitude: result.dados.enderecoscomponentes.destino.latitude,
            longitude: result.dados.enderecoscomponentes.destino.longitude,
            title: "Destino",
          });
        }
        if (!!result.dados && !!result.dados.destinos) {
          setDestinos(result.dados.destinos);
        }
        setMarcadores(m);
        delayDeactivateLoader();
      });
    }
  };

  const cancelaCorrida = () => {
    setShowLoader(true);

    WS.cancelaCorrida(xd).then((resposta) => {
      console.log(resposta)
      if (!!resposta.status) {
        startOtpTimer();
        setShowOtp(true);
        delayDeactivateLoader();
      } else {
        delayDeactivateLoader();
        if (resposta.msgerro) {
          setMsgErro(resposta.msgerro);
        } else {
          setMsgErro("Erro ao solicitar a corrida, verifique a conexão com a internet e tente novamente");
        }
      }
    });
  };

  const startOtpTimer = async () => {
    await setTimerOtp(35);
    console.log("startOtpTimer", timerOtp);
    if (incrementer.current) clearInterval(incrementer.current);
    incrementer.current = setInterval(() => {
      setTimerOtp((tempoAtual) => {
        if (tempoAtual <= 1) {
          clearInterval(incrementer.current);
          return 0;
        }
        return tempoAtual - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    setShowLoader(true);
    //create a timer to call loadCorrida() every 10s
    const interval = setInterval(() => {
      loadCorrida();
    }, 10000);

    return () => clearInterval(interval);
  }, [xd]);
  const delayDeactivateLoader = () => {
    setTimeout(() => setShowLoader(false), 1000);
  };

  const hideOtp = () => {
    setShowOtp(false);
    loadCorrida();
  };


  const validadeCode = async (code) => {
    WS.cancelaCorridaConfirma(xd, code).then((resposta) => {
      if (!resposta.error) {
        setShowOtp(false);
        loadCorrida();
      } else {
        delayDeactivateLoader();
        if (resposta.msgerro) {
          setMsgErro(resposta.msgerro);
        } else {
          setMsgErro("Erro ao cancelar a corrida, verifique a conexão com a internet e tente novamente");
        }
      }
    });
  };

  let showMsgErro = msgErro != "";
  let podeCancelar =
    (statusCorrida === "CORRIDA_EM_ANDAMENTO" || statusCorrida === "CORRIDA" || statusCorrida === "CORRIDA_PENDENTE") && !corrida.dataHoraQrl;
  return (
    <S.AppContainer>
      <GoMap alturaOffSet={alturaFilhoTopo} mark1={motorista_marker} mark2={marcadores} c_points={pontos} ec_points1={pontos2} />
      <ObserverAltura onAlturaMudou={setAlturaFilhoTopo} style={{ pbackground: "#e0f7fa" }}>
        <DadosMotorista motorista={motorista} dados={motorista_dados} />

        <S.DetailBox>
          <StatusCorrida corrida={corrida} status={statusCorrida} trajeto={trajeto} />
          <DestinosOrganizado origem={origem} destinos={destinos} />
        </S.DetailBox>
        <StarAvaliacao corrida={corrida} status={statusCorrida} questoes={questoes} avaliarCorrida={avaliarCorrida} />
        <S.DetailBox>
          <S.PagamentoCard>
            <WhatsappShareButton url={window.location.href} title="Acompanhe minha corrida ">
              <S.Compartilhe>
                Compartinhe <WhatsappIcon size={32} color="#F77317" />
              </S.Compartilhe>
            </WhatsappShareButton>
            {podeCancelar && <S.PrimaryButtonLittle onClick={cancelaCorrida}>Cancelar Corrida</S.PrimaryButtonLittle>}
          </S.PagamentoCard>
        </S.DetailBox>
      </ObserverAltura>

      {showOtp && (
        <OtpPrompt
          uuid={xd}
          ip={xd}
          timerOtp={timerOtp}
          showMsgErro={showMsgErro}
          msgErro={msgErro}
          resent={cancelaCorrida}
          updateOtp={validadeCode}
          voltar={hideOtp}
          showVoltar={true}
          titulo={"O código de segurança foi enviado para seu telefone e email."}
        />
      )}

      {showLoader && <Loader text={"Aguarde, procurando um motorista..."} />}
    </S.AppContainer>
  );
}

export default Main;
